import * as RadixDialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

import { DrawerPanelContent, DrawerPanelOverlay } from './DrawerPanel.styles';

import type { ReactElement, ReactNode } from 'react';

type DrawerPanelProps = {
  accessibilityTitle?: string;
  children: ReactNode;
  isCloseDisabled?: boolean;
  isOpen: boolean;
  onClose: () => void;
  side?: 'left' | 'right';
  trigger?: ReactElement;
  widthOverride?: string;
};

export const DrawerPanel = ({
  accessibilityTitle = 'Panel',
  children,
  isCloseDisabled = false,
  isOpen,
  onClose,
  side = 'right',
  trigger,
  widthOverride,
}: DrawerPanelProps) => (
  <RadixDialog.Root
    onOpenChange={(open) => {
      if (!open && !isCloseDisabled) {
        onClose();
      }
    }}
    open={isOpen}
  >
    {trigger && <RadixDialog.Trigger asChild>{trigger}</RadixDialog.Trigger>}
    <RadixDialog.Portal>
      <DrawerPanelOverlay />
      <DrawerPanelContent
        $side={side}
        $widthOverride={widthOverride}
        onEscapeKeyDown={(event) => {
          if (isCloseDisabled) {
            event.preventDefault();
          }
        }}
        onPointerDownOutside={(event) => {
          if (isCloseDisabled) {
            event.preventDefault();
          }
        }}
      >
        <VisuallyHidden asChild>
          <RadixDialog.Title>{accessibilityTitle}</RadixDialog.Title>
        </VisuallyHidden>
        <VisuallyHidden asChild>
          <RadixDialog.Description>{accessibilityTitle}</RadixDialog.Description>
        </VisuallyHidden>
        {children}
      </DrawerPanelContent>
    </RadixDialog.Portal>
  </RadixDialog.Root>
);
